/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ groups: NonNullable<unknown>, projects: NonNullable<unknown>, failures: NonNullable<unknown> }} Explorer_Info_Batch_Complete_SummaryInputs */

const en_explorer_info_batch_complete_summary = /** @type {(inputs: Explorer_Info_Batch_Complete_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exported ${i?.groups} group(s) from ${i?.projects} project(s). ${i?.failures} failure(s).`)
};

const fr_explorer_info_batch_complete_summary = /** @type {(inputs: Explorer_Info_Batch_Complete_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Groupe(s) ${i?.groups} exporté(s) du/des projet(s) ${i?.projects}. Échec(s) ${i?.failures}.`)
};

const de_explorer_info_batch_complete_summary = /** @type {(inputs: Explorer_Info_Batch_Complete_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.groups}-Gruppe(n) aus ${i?.projects}-Projekt(en) exportiert. ${i?.failures}-Fehler.`)
};

const it_explorer_info_batch_complete_summary = /** @type {(inputs: Explorer_Info_Batch_Complete_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esportati ${i?.groups} gruppi dal/dai progetto/i ${i?.projects}. ${i?.failures} errori.`)
};

const ru_explorer_info_batch_complete_summary = /** @type {(inputs: Explorer_Info_Batch_Complete_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Группа(ы) ${i?.groups} экспортирована из проекта(ов) ${i?.projects}. ${i?.failures} завершилась с ошибкой(ами).`)
};

const es_explorer_info_batch_complete_summary = /** @type {(inputs: Explorer_Info_Batch_Complete_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se exportaron grupos ${i?.groups} desde proyectos ${i?.projects}. Fallos ${i?.failures}.`)
};

const zh_cn2_explorer_info_batch_complete_summary = /** @type {(inputs: Explorer_Info_Batch_Complete_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`从 ${i?.projects} 项目导出 ${i?.groups} 组。${i?.failures} 失败。`)
};

const ja_explorer_info_batch_complete_summary = /** @type {(inputs: Explorer_Info_Batch_Complete_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.groups} グループを ${i?.projects} プロジェクトからエクスポートしました。${i?.failures} でエラーが発生しました。`)
};

const hi_explorer_info_batch_complete_summary = /** @type {(inputs: Explorer_Info_Batch_Complete_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.projects} प्रोजेक्ट(ओं) से ${i?.groups} समूह(ओं) का निर्यात किया गया। ${i?.failures} विफलता(याँ)।`)
};

const pt_pt2_explorer_info_batch_complete_summary = /** @type {(inputs: Explorer_Info_Batch_Complete_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Grupo(s) ${i?.groups} exportado(s) do(s) projeto(s) ${i?.projects}. Falha(s) ${i?.failures}.`)
};

/**
* | output |
* | --- |
* | "Exported {groups} group(s) from {projects} project(s). {failures} failure(s)." |
*
* @param {Explorer_Info_Batch_Complete_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_complete_summary = /** @type {((inputs: Explorer_Info_Batch_Complete_SummaryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Complete_SummaryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_complete_summary(inputs)
	if (locale === "de") return de_explorer_info_batch_complete_summary(inputs)
	if (locale === "it") return it_explorer_info_batch_complete_summary(inputs)
	if (locale === "ru") return ru_explorer_info_batch_complete_summary(inputs)
	if (locale === "es") return es_explorer_info_batch_complete_summary(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_complete_summary(inputs)
	if (locale === "ja") return ja_explorer_info_batch_complete_summary(inputs)
	if (locale === "hi") return hi_explorer_info_batch_complete_summary(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_complete_summary(inputs)
	return en_explorer_info_batch_complete_summary(inputs)
});